/*
 * @Author: lkw199711 lkw199711@163.com
 * @Date: 2023-10-31 21:45:44
 * @LastEditors: lkw199711 lkw199711@163.com
 * @LastEditTime: 2023-10-31 22:11:48
 * @FilePath: /smanga/src/store/image.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { defineStore } from 'pinia';

const usePosterStore = defineStore<any>('poster', {
    state: () => {
        return {
            
        }
    }
})

export default usePosterStore;
// app.use(createPinia());